import { render } from "./CardAcessoPublico.vue?vue&type=template&id=48cbcce2"
import script from "./CardAcessoPublico.vue?vue&type=script&lang=js"
export * from "./CardAcessoPublico.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__